/* Accessibility enhancements (additive — does not modify theme/vendor JS)
   Batch 4: keyboard & focus for the mobile menu and search.
   WCAG 2.1.1, 2.1.2, 2.4.3, 4.1.2 */
(function () {
  function ready(fn) {
    if (document.readyState !== 'loading') fn();
    else document.addEventListener('DOMContentLoaded', fn);
  }

  ready(function () {
    var toggle = document.querySelector('.toggle-menus');
    var menu = document.getElementById('NavMenus');

    if (toggle) {
      toggle.setAttribute('role', 'button');
      toggle.setAttribute('aria-controls', 'NavMenus');

      var setExpanded = function () {
        toggle.setAttribute(
          'aria-expanded',
          toggle.classList.contains('toggle-menus--open') ? 'true' : 'false'
        );
      };
      setExpanded();

      // Keep aria-expanded in sync with ANY change to the toggle's class
      // (covers the menu being closed by opening search, resize, etc.).
      if (window.MutationObserver) {
        new MutationObserver(setExpanded).observe(toggle, {
          attributes: true,
          attributeFilter: ['class']
        });
      }

      // Move focus into the menu only when it actually opens.
      toggle.addEventListener('click', function () {
        window.setTimeout(function () {
          if (!toggle.classList.contains('toggle-menus--open') || !menu) return;
          var first = menu.querySelector(
            'a[href]:not([tabindex="-1"]), button:not([disabled]), input:not([type="hidden"]):not([disabled])'
          );
          if (first && first.offsetParent !== null) first.focus();
        }, 50);
      });

      // Space activates the anchor-as-button.
      toggle.addEventListener('keydown', function (e) {
        if (e.key === ' ' || e.key === 'Spacebar') { e.preventDefault(); toggle.click(); }
      });

      // Escape closes the open menu and returns focus to the toggle.
      document.addEventListener('keydown', function (e) {
        if ((e.key === 'Escape' || e.key === 'Esc') &&
            toggle.classList.contains('toggle-menus--open')) {
          toggle.click();      // reuse the theme's close logic; observer updates aria-expanded
          toggle.focus();
        }
      });
    }

    // Search: focus the field ONLY when the panel is actually open
    // (avoid stealing focus on the close click, which re-hides the input).
    var searchToggle = document.getElementById('SearchToggle');
    if (searchToggle) {
      searchToggle.addEventListener('click', function () {
        window.setTimeout(function () {
          var openPanel = document.querySelector('.search.search--open');
          if (!openPanel) return;
          var input = openPanel.querySelector('.search-query');
          if (input) input.focus();
        }, 90);
      });
    }

    // Quantity steppers are focusable <span>s with click handlers — make
    // Enter/Space activate them like a real button. Delegated so it also
    // works for cart line items rendered after load. (WCAG 2.1.1)
    document.addEventListener('keydown', function (e) {
      var el = e.target;
      if (el && el.classList && el.classList.contains('js-qty__adjust')) {
        // Only Space here — the theme already activates Enter via its own keyup
        // handler, so handling Enter too would double-fire (Codex review).
        if (e.key === ' ' || e.key === 'Spacebar') {
          e.preventDefault();
          el.click();
        }
      }
    });

    /* ---- Keep off-screen slider slides out of the tab order ----
       Slick marks off-screen slides aria-hidden="true" but leaves their
       links focusable → focusable-inside-aria-hidden (WCAG 4.1.2). Demote
       those to tabindex=-1 and restore when the slide becomes visible. */
    var FOCUSABLE = 'a[href], button, input, select, textarea, [tabindex]';
    function demote(el) {
      if (el.getAttribute('tabindex') === '-1') return;
      if (!el.hasAttribute('data-a11y-prevti')) {
        el.setAttribute('data-a11y-prevti', el.getAttribute('tabindex') === null ? '__none__' : el.getAttribute('tabindex'));
      }
      el.setAttribute('tabindex', '-1');
    }
    function syncHiddenFocusables() {
      // Carousel libraries (Slick, Flickity) make their slides/containers a tab
      // stop with tabindex="0" but give them no interactive role, and Flickity
      // adds aria-selected to grid cells that have no supporting role. Neither is
      // valid or useful for assistive tech (the links/arrows inside remain
      // reachable), so normalize them.
      document.querySelectorAll('.slick-slide[tabindex="0"], .flickity-enabled[tabindex="0"], .product-grid--horizontally[tabindex="0"]').forEach(function (s) {
        s.setAttribute('tabindex', '-1');
      });
      document.querySelectorAll('.product-item[aria-selected], .flickity-slider [aria-selected]').forEach(function (el) {
        el.removeAttribute('aria-selected');
      });
      document.querySelectorAll('[aria-hidden="true"]').forEach(function (h) {
        // The aria-hidden element itself may be focusable (Slick puts
        // tabindex="0" on slides), plus any focusable descendants.
        if (h.hasAttribute('tabindex')) demote(h);
        h.querySelectorAll(FOCUSABLE).forEach(demote);
      });
      document.querySelectorAll('[data-a11y-prevti]').forEach(function (el) {
        if (el.getAttribute('aria-hidden') !== 'true' && !el.closest('[aria-hidden="true"]')) {
          var prev = el.getAttribute('data-a11y-prevti');
          if (prev === '__none__') el.removeAttribute('tabindex');
          else el.setAttribute('tabindex', prev);
          el.removeAttribute('data-a11y-prevti');
        }
      });
    }
    // Watch the whole page for aria-hidden/tabindex changes (auto-rotating
    // sliders re-set tabindex on every transition). Debounced via rAF; demote()
    // is idempotent so this can't loop.
    if (window.MutationObserver) {
      var scheduled = false;
      var mo = new MutationObserver(function () {
        if (scheduled) return;
        scheduled = true;
        window.requestAnimationFrame(function () { scheduled = false; syncHiddenFocusables(); });
      });
      mo.observe(document.body, { attributes: true, subtree: true, attributeFilter: ['aria-hidden', 'tabindex', 'aria-selected'] });
    }
    syncHiddenFocusables();
    window.setTimeout(syncHiddenFocusables, 1500); // Slick/Flickity initialise late
    window.setTimeout(syncHiddenFocusables, 3500);
  });

  /* ---- Predictive search: ARIA combobox / listbox pattern (WCAG 4.1.2 / 1.3.1) ----
     The theme injects product cards into .search__results-list as the user types.
     We expose the input as a combobox, the results list as a listbox, and each
     product link as an option; arrow keys move aria-activedescendant, Enter opens
     the active result, Escape clears, and a live region announces the count.
     Secondary card controls (quick-view / wishlist) are removed from the option's
     exposed semantics so no interactive control is nested inside an option. */
  function setupSearchCombobox() {
    var input = document.querySelector('.search-query');
    var list = document.querySelector('.search__results-list');
    if (!input || !list) return false;
    if (input.getAttribute('data-a11y-combobox')) return true;
    input.setAttribute('data-a11y-combobox', '1');

    list.id = list.id || 'a11y-search-listbox';
    list.setAttribute('role', 'listbox');
    list.setAttribute('aria-label', 'Search results');
    input.setAttribute('role', 'combobox');
    input.setAttribute('aria-autocomplete', 'list');
    input.setAttribute('aria-haspopup', 'listbox');
    input.setAttribute('aria-controls', list.id);
    input.setAttribute('aria-expanded', 'false');

    var live = document.createElement('div');
    live.className = 'visually-hidden';
    live.setAttribute('aria-live', 'polite');
    live.setAttribute('role', 'status');
    (input.parentNode || list).appendChild(live);

    var options = [], lastSig = '';

    // Active option is tracked by aria-activedescendant on the input (read from the
    // DOM each time) rather than a stored index, so it survives the theme
    // re-rendering the result nodes between keystrokes.
    function getIndex() {
      var id = input.getAttribute('aria-activedescendant');
      if (!id) return -1;
      for (var i = 0; i < options.length; i++) { if (options[i].id === id) return i; }
      return -1;
    }
    function clearActive() {
      options.forEach(function (o) { o.setAttribute('aria-selected', 'false'); o.classList.remove('a11y-search-active'); });
      input.removeAttribute('aria-activedescendant');
    }
    function setActive(i) {
      if (!options.length) return;
      if (i < 0) i = options.length - 1;
      if (i >= options.length) i = 0;
      options.forEach(function (o) { o.setAttribute('aria-selected', 'false'); o.classList.remove('a11y-search-active'); });
      var o = options[i];
      o.setAttribute('aria-selected', 'true');
      o.classList.add('a11y-search-active');
      input.setAttribute('aria-activedescendant', o.id);
      if (o.scrollIntoView) o.scrollIntoView({ block: 'nearest' });
    }
    function refresh() {
      var items = list.querySelectorAll('.product-item');
      var newOpts = [];
      items.forEach(function (it, i) {
        it.setAttribute('role', 'presentation');
        var link = it.querySelector('a.product-link');
        if (link) {
          link.setAttribute('role', 'option');
          if (!link.id) link.id = 'a11y-sopt-' + i;
          if (!link.getAttribute('aria-selected')) link.setAttribute('aria-selected', 'false');
          link.setAttribute('tabindex', '-1');
          newOpts.push(link);
        }
        // keep secondary card controls out of the tab order (tabindex only — no
        // aria-hidden, which would otherwise flag aria-hidden-focus)
        it.querySelectorAll('a:not(.product-link), button').forEach(function (el) {
          el.setAttribute('tabindex', '-1');
        });
      });
      var sig = newOpts.map(function (o) { return o.id; }).join('|');
      options = newOpts;
      input.setAttribute('aria-expanded', options.length ? 'true' : 'false');
      if (sig !== lastSig) {
        // genuinely new result set: clear selection and announce the count
        lastSig = sig;
        clearActive();
        if (options.length) live.textContent = options.length + (options.length === 1 ? ' result available.' : ' results available.');
      } else {
        // same set re-rendered into fresh nodes: re-apply the active highlight
        var idx = getIndex();
        if (idx >= 0) setActive(idx);
      }
    }

    if (window.MutationObserver) {
      var t;
      new MutationObserver(function () {
        window.clearTimeout(t);
        t = window.setTimeout(refresh, 60);
      }).observe(list, { childList: true });   // direct children only (result items)
    }

    input.addEventListener('keydown', function (e) {
      var esc = (e.key === 'Escape' || e.key === 'Esc');
      // Re-resolve options straight from the DOM on every keypress so navigation
      // never depends on observer timing or a stale closure array.
      options = [].slice.call(list.querySelectorAll('a.product-link'));
      options.forEach(function (o, i) {
        if (o.getAttribute('role') !== 'option') o.setAttribute('role', 'option');
        if (!o.id) o.id = 'a11y-sopt-' + i;
        o.setAttribute('tabindex', '-1');
      });
      if (!options.length && !esc) return;
      if (e.key === 'ArrowDown') { e.preventDefault(); setActive(getIndex() + 1); }
      else if (e.key === 'ArrowUp') { e.preventDefault(); setActive(getIndex() - 1); }
      else if (e.key === 'Enter') {
        var i = getIndex();
        if (i >= 0 && options[i]) {
          var href = options[i].getAttribute('href');
          if (href) { e.preventDefault(); window.location.href = href; }
        }
      } else if (esc) {
        clearActive();
      }
    });
    refresh();
    return true;
  }

  // The search panel may be injected after DOMContentLoaded — set up as soon as
  // it appears, with a body observer plus timed retries, then stop.
  ready(function () {
    if (setupSearchCombobox()) return;
    var bo = window.MutationObserver ? new MutationObserver(function () {
      if (setupSearchCombobox() && bo) { bo.disconnect(); bo = null; }
    }) : null;
    if (bo) bo.observe(document.body, { childList: true, subtree: true });
    [400, 1200, 3000].forEach(function (ms) { window.setTimeout(setupSearchCombobox, ms); });
  });
})();
